/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Files_Processing_NoticeInputs */



/**
* | output |
* | --- |
* | "Files are being processed - the AI won't have access until embedding is complete" |
*
* @param {Chat_Files_Processing_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_files_processing_notice = /** @type {((inputs?: Chat_Files_Processing_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Files_Processing_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien werden verarbeitet - die KI hat erst nach Abschluss des Embeddings Zugriff")
	return /** @type {LocalizedString} */ ("Files are being processed - the AI won't have access until embedding is complete")
});